<template>
  <div class="h-screen">
    <navigation-bar/>
    <div class="flex flex-row items-stretch h-full bg-gray-200 ">


      <div class="flex-none w-1/4 max-w-sm text-gray-700 bg-indigo-800">

        <div class="mx-4 mt-4">
          <!-- Top Text Description -->
          <div class="block uppercase tracking-wide text-white text-xs font-bold mb-2">
            My conversations
          </div>

          <!-- Conversation List Boxes -->
          <div v-for="conversation in conversations_array" class="">

            <!-- Conversation box -->
            <div class="mt-4">
              <div class="flex items-center">
                <div class="flex-none w-10 h-10 rounded-md mr-2 bg-blue-300">
                </div>
                <div class="text-white">
                  <p class="text-lg leading-none font-normal">{{conversation.fun_name}}</p>
                  <!-- <p class="text-sm font-thin">{{ new Date(conversation.created_at) | moment('MMM Do, h:mm a') }}</p> -->
                  <p class="text-sm font-thin">{{ new Date(conversation.created_at) | moment("from", "now") }}</p>
                  <p v-if="conversation.call_state == 'widget-calling'" class="text-sm font-thin">Receiving Call{{dots}}</p>
                  <p v-if="conversation.call_state == 'active-call'" class="text-sm font-thin">On Call</p>
                  <p v-if="conversation.call_state == 'call-ended'" class="text-sm font-thin">Call Ended</p>
                  <!-- <p class="text-sm font-thin">Toronto, Canada</p> -->
                </div>
                <div class="ml-auto">
                  <!-- <button
                    v-if="conversation.call_state == 'widget-calling'"
                    @click="answerSimplePeer(conversation.conv_key)"
                    class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
                    >
                    Answer
                  </button> -->
                  <!-- Video Off Button -->
                  <div
                    v-if="conversation.call_state == 'widget-calling'"
                    @click="answerSimplePeer(conversation.conv_key)"
                    class="flex flex-col items-center">
                    <div class="bg-green-500 rounded-full h-12 w-12 flex items-center justify-center shadow-lg hover:shadow-xl hover:bg-green-700">
                      <img class="h-6 w-6" src="../assets/icons/Master Icon/Video.svg">
                    </div>
                    <!-- <p v-if="videoTracksEnabled" class="m-0 font-sans text-sm text-gray-900 font-hairline">video off</p> -->
                    <!-- <p v-else class="m-0 font-sans text-sm text-gray-900 font-hairline">video on</p> -->
                  </div>
                  <span
                    v-if="conversation.call_state == 'active-call'"
                    class="inline-block bg-green-200 rounded-full px-3 py-1 text-sm font-semibold text-green-800">
                    On Call
                  </span>
                  <!-- <span
                    v-if="conversation.call_state == 'call-ended'"
                    class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700">
                    ended
                  </span> -->
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Right Video Chat Container -->
        <div class="w-full">

          <!-- Chat info bar -->
          <div class="flex items-center justify-center bg-white shadow-lg h-24">
            <div class="flex w-10/12">
              <div class="text-gray-900">
                <p class="text-2xl my-2 leading-none font-normal">SoilFlo</p>
                <p class="text-sm my-2 font-thin">Admin Dash</p>
              </div>
            </div>
          </div>
          <!-- Video container w. gutters-->
          <div
            v-if="conversationView.isVideoCallVisible"
            class="flex justify-center">
            <div class="w-10/12">
              <!-- video container -->
              <div class="relative w-full">

                <!-- Large Video Stream -->
                <video
                class="video object-cover rounded-lg shadow-2xl mt-16 w-full bg-black"
                autoplay
                :src-object.prop.camel="localStream"
                muted
                >
                </video>

                <!-- Mini Video Stream -->
                <video
                  class="absolute top-0 right-0 w-1/4 object-cover shadow-lg rounded-lg m-3"
                  autoplay
                  :src-object.prop.camel="remoteStream"
                  >
                </video>
              </div>

              <!-- buttons container -->
              <div class="flex justify-around py-4">

                <!-- Video Off Button -->
                <div @click="toggleVideo()" class="flex flex-col items-center">
                  <div class="m-0 mb-2 bg-gray-600 rounded-full h-16 w-16 flex items-center justify-center shadow-lg hover:shadow-xl hover:bg-gray-700">
                    <img
                      v-if="videoTracksEnabled"
                      class="h-8 w-8"
                      src="../assets/icons/Master Icon/Video-Off.svg"
                    >
                    <img
                      v-else
                      class="h-8 w-8"
                      src="../assets/icons/Master Icon/Video.svg"
                    >
                  </div>
                  <p v-if="videoTracksEnabled" class="m-0 font-sans text-sm text-gray-900 font-hairline">video off</p>
                  <p v-else class="m-0 font-sans text-sm text-gray-900 font-hairline">video on</p>
                </div>

                <!-- End Call -->
                <div @click="endCall()" class="flex flex-col items-center">
                  <div class="m-0 mb-2 bg-red-600 rounded-full h-16 w-16 flex items-center justify-center shadow-lg hover:shadow-xl hover:bg-red-700">
                    <img class="h-8 w-8" src="../assets/icons/Master Icon/Cross.svg">
                  </div>
                  <p class="m-0 font-sans text-sm text-gray-900 font-hairline">End Call</p>
                </div>

              </div>

            </div>
          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import NavigationBar from './NavigationBar.vue'
import { mapGetters, mapState } from "vuex";
// import firebase from "firebase";
import firebase, {db} from '@/utils/firebase'
import Peer from 'simple-peer'

export default {

  components: {
    'navigation-bar': NavigationBar
  },

  data() {
    return {
      callState:'no-call', //no-call -> active-call -> call-ended
      conversations: null,
      localStream: null,
      videoTracksEnabled:true,
      remoteStream: null,
      peer: null,
      conversations_array: null,
      conversation_active: null,
      audio:null,
      dots: null,
      conversationView: {
        isVideoCallVisible: false
      }

    }
  },

  methods: {


    getConversations(company_id){
      const confRef = db.ref('conversations')
      confRef.orderByChild('company_id')
      .equalTo(company_id)
      .on('value', snapshot => {
        this.conversations = snapshot.val()
        //create a sorted array - TODO:could be moved to a computed function
        const conversations_array = []
        snapshot.forEach(function(childNode){
          const conv = childNode.val()
          conv['conv_key'] = childNode.key
          conversations_array.push(conv)
        });
        conversations_array.sort(function(a,b){
          return b.created_at - a.created_at
        });
        this.conversations_array = conversations_array.slice(0,10)
      });
    },

    // createPeer(){
    //   const peer = new Peer({
    //     initiator: true,
    //     trickle: true,
    //     // stream: stream,
    //     config: {'iceServers': [
    //       {'urls': 'stun:stun.services.mozilla.com'},
    //       {'urls': 'stun:stun.l.google.com:19302'},
    //       {'urls': 'turn:numb.viagenie.ca','credential': 'beaver','username': 'webrtc.websitebeaver@gmail.com'}
    //     ]}
    //   });
    //   // this.peer = peer
    //   return peer;
    // },

    answerSimplePeer(conversation_id){


      navigator.mediaDevices.getUserMedia({audio:true, video:true})
      .then(dashboardStream => {
        this.localStream = dashboardStream
        this.callState = 'active-call'
        var peer = new Peer({
          initiator: false,
          trickle: true,
          // stream: stream,
          config: {'iceServers': [
            {'urls': 'stun:stun.services.mozilla.com'},
            {'urls': 'stun:stun.l.google.com:19302'},
            {'urls': 'turn:numb.viagenie.ca','credential': 'beaver','username': 'webrtc.websitebeaver@gmail.com'}
          ]}
        })
        console.log(dashboardStream.getTracks())

        this.peer = peer
        // this.peer = this.createPeer()
        this.peer.addStream(dashboardStream)

        //get data from the widget and add it to the dashboard peer
        const peerDataRef = firebase.database().ref('conversations/'+ conversation_id + '/peer_data/')

        //send data to from the dashboard to the widget on new signals
        this.peer.on('signal', data => {
          // var convKey = this.keys[0]
          const json_data = JSON.parse( JSON.stringify(data ) )
          const convRef = firebase.database().ref('conversations/'+ conversation_id + '/peer_data/')
          const updatedConv = convRef.push({
            data: json_data,
            source: 'dashboard'
          })
          // console.log("updated: ", updatedConv)
        });

        peerDataRef.once('value', snapshot => {
          const allPeerData = snapshot.val()
          //for each of the peer_data records, add the widget ones to the peer
          for (const item in snapshot.val()){
            const peer_data_item = snapshot.val()[item]
            if (peer_data_item.source === 'widget'){
              // console.log('Widget Data:')
              // console.log(peer_data_item)
              this.peer.signal(peer_data_item.data)
            }
          }
        });

        this.peer.on('stream', stream => {
          // got remote video stream, now let's show it in a video tag
          this.remoteStream = stream
          console.log(this.remoteStream)
        });

        // peer.on('track', (track, stream) => {
        //   this.remoteStream = stream
        //   console.log(this.remoteStream)
        // })

        this.peer.on('close', () => {
          this.endCall()
          // console.log('THE PEER HAS BEEN CLOSED M8')
          // this.localStream = null;
          // this.remoteStream = null;
        })

        this.peer.on('error', (err) => {
          this.stopStream(this.localStream)
        });

      })
      .catch(function(err) {
        console.log(err)
      });
    },

    stopStream(stream){
      const tracks = stream.getTracks();
      tracks.forEach(function(track) {
        track.stop();
      });
    },

    endCall(){
      this.stopStream(this.localStream)
      this.callState = 'call-ended'
      this.peer.destroy()
      this.remoteStream = null;


    },

    toggleVideo(){
      var videoTracks = this.localStream.getVideoTracks();
      videoTracks.forEach(t => {
        t.enabled = !t.enabled
        this.videoTracksEnabled = t.enabled
      })
    },

    playSound(sound, loop=false) {
      if(sound) {
        this.audio = new Audio(sound);
        this.audio.loop = loop;
        this.audio.play().loop;
      }
    },

    createDots(){
      var counter = 0;
      setInterval(() => {
        var dots = '.'
        this.dots = dots.repeat(counter)
        counter ++
        if(counter > 3){
          counter = 0
        }
      }, 500);
    },


  },


  computed: {

    ...mapGetters({
      'user': 'user',
      'fb_user_data': 'fb_user_data',
      'state_conversations': 'state_conversations',
      'companies': 'companies'
    }),
  },

  watch: {
    'fb_user_data': {
      handler (newVal) {
        if (newVal) { // check if userid is available
          this.getConversations(this.fb_user_data.companyId)
        }
      },
      immediate: true // make this watch function is called when component created
    },
    callState(newValue){
      if(newValue == 'no-call'){
        this.conversationView.isVideoCallVisible = false;
      }
      if(newValue == 'active-call'){
        this.conversationView.isVideoCallVisible = true;
      }
      if(newValue == 'call-ended'){
        this.conversationView.isVideoCallVisible = false;
      }
    }
  },

  mounted() {
    this.createDots()
    this.$store.dispatch('bindCompanies')
    // this.$store.dispatch('bindConversations')

  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
